export default function AboutData() {
    return {
        title: "About Disability Income",
        content:
            "What would happen if you became unable to work due to an injury or illness? With disability income insurance, you’ll receive a portion of your income while you’re unable to work. That way, you can focus on getting well, knowing your bills are covered.",
    }
}